module.exports = __webpack_public_path__ + "img/ssl-certifikaty.c6b2a237.svg";